
import { bignumber, multiply, divide, add, subtract } from 'mathjs'
import Web3 from 'web3';
import config from '../config/config';
import { convert } from './convert';

import moment from 'moment';

export function isAddress(address) {
    var web3 = new Web3(config.rpc);
    var status = web3.utils.isAddress(address);
    return status;
}


export function dateFormat(date, format) {

    if (date && date !== '' && format && format !== '') {
        var cDate = moment(date).format(format);
        return cDate;
    } else {
        return '-';
    }
}

export async function percentage(amount, percentage, type) {

    var result = 0;
    var initialamt = 0;
    if (type === "minus") {
        initialamt = parseFloat(amount) * parseFloat(percentage) / 100;
        let amt = parseFloat(amount) - parseFloat(initialamt);
        let amt1 = await convert(amt);
        result = amt1;
    } else if (type === "add") {
        initialamt = parseFloat(amount) * parseFloat(percentage) / 100;
        let amt = parseFloat(amount) + parseFloat(initialamt);
        let amt1 = await convert(amt);
        result = amt1;
    } else if (type === "percentage") {
        initialamt = parseFloat(amount) * parseFloat(percentage) / 100;
        let amt1 = await convert(initialamt);
        result = amt1;
    }

    result = await isNumberCheck(result);
    return result;
}


export async function getdeadline(minutes) {

    if (minutes === "" || minutes <= 0) {
        minutes = 2;
    }
    var deadline = parseInt(Date.now() / 1000) + minutes * 60;
    return deadline;
}

export async function toFixedFormat(amount) {

    var result = 0;

    try {
        var number = amount.toString();
        var number1 = number.split(".");

        if (number1[1] && number1[1].length && number1[1].length > 0) {
            var length = number1[1].length;
            if (length > 5) {
                length = config.toFixed;
            }
            result = amount.toFixed(length);
        } else {
            result = amount;
        }

        result = await isNumberCheck(result);

        return result;

    } catch (err) {
        return result;
    }

}

export async function divideDecimal(amount, decimals) {
    var amt = amount / 10 ** decimals;
    var convertamt = await convert(amt);
    var cAmt = await toFixedFormat(convertamt);
    cAmt = await isNumberCheck(cAmt);
    return cAmt;
}

export function numberFloatOnly(value) {
    //eslint-disable-next-line
    const regxFormat = /^[]?\d*(?:[.]\d*)?$/;
    var result = regxFormat.test(value)
    return result;
}

export function numberOnly(value) {
    try {
        const regxFormat = /^[0-9]*$/;
        var result = regxFormat.test(value)
        return result;
    } catch (err) {
        console.log(err, "numberOnly")
        return false;
    }

}

export function isFirstLetterCaps(str) {
    try {
        var first = str.charAt(0).toUpperCase();
        var letter = str.slice(1)
        var fullname = first + letter
        return fullname
    } catch (err) {
        return "";
    }
}

export function roundAmt(value) {
    try {
        var Amount = Math.floor(value)
        return Amount;
    } catch (err) {
        return "";
    }
}

export function shortValue(value) {
    try {
        let decimal = localStorage.getItem('displaydecimal')
        if (decimal) {
            var Amount = value.toFixed(decimal);
            return Amount
        } else {
            var Amount = value.toFixed(2);
            return Amount
        }
    } catch (err) {
        return "";
    }
}

export function formatAddress(address) {
    try {
        var addr = address.substring(0, 16);
        var addr1 = address.substring(30, 42);
        var concat = addr + "...." + addr1;
        return concat;
    } catch (err) {
        return "";
    }
}

export function shortText(address) {
    try {
        var addr = address.substring(0, 4);
        var addr1 = address.substring(36, 42);
        var concat = addr + "...." + addr1;
        return concat;
    } catch (err) {
        return "";
    }
}

export async function division(amountA, amountB) {
    var amt = amountA / amountB;
    var convertamt = await convert(amt);
    convertamt = await isNumberCheck(convertamt);
    return convertamt;
}

export async function multiply1(amountA, amountB) {
    var amt = amountA * amountB;
    var convertamt = await convert(amt);
    convertamt = await isNumberCheck(convertamt);
    return convertamt;
}


export function toFixedWithoutRound(number, decimalPlaces = 2) {
    try {
        let numberString = number.toString();
        let decimalIndex = numberString.indexOf('.');
        if (decimalIndex === -1) {
            return number;
        }
        numberString = numberString.slice(0, decimalIndex + decimalPlaces + 1);
        let truncatedNumber = parseFloat(numberString);
        return truncatedNumber;
    } catch (err) {
        return 0;
    }

}

export function isNumberCheck(amount) {
    var numberVal = amount;
    var convertamt = (isFinite(numberVal) && numberVal !== "Infinity") ? numberVal : 0;
    return convertamt;
}

export async function ChecktokenDecimal(amount, decimals) {
    var result = 0;
    var decimalsLength = 18;
    if (decimals && decimals > 0) {
        decimalsLength = decimals;
    }
    try {
        var number = amount.toString();
        var number1 = number.split(".");

        if (number1[1] && number1[1].length && number1[1].length > 0) {
            var length = number1[1].length;
            if (length > decimalsLength) {
                length = decimals;
            }
            result = amount.toFixed(length);
        } else {
            result = amount;
        }

        result = await isNumberCheck(result);

        return result;

    } catch (err) {
        return result;
    }

}

export function formatData(data) {
    try {
        var field = data.field;
        var fstart = parseInt(data.fstart);
        var fend = parseInt(data.fend);
        var lstart = parseInt(data.lstart);
        var lend = parseInt(data.lend);
        var addr = field.substring(fstart, fend);
        var addr1 = field.substring(lstart, lend);
        var concat = addr + "...." + addr1;
        return concat;
    } catch (err) {
        return "";
    }
}

export async function toFixedGreater(amount) {

    var deciChk = amount.toString();
    deciChk = deciChk.split('.');

    if (deciChk && deciChk.length === 2) {

        const getNumber = deciChk[1].split("");
        for (let n = 0; n < getNumber.length; n++) {

            var num = parseInt(getNumber);
            if (num > 0) {

            }

        }


    }

}

export function getNetworkName(id) {
    id = parseInt(id);
    try {
        var text = (id === 56) ? "BNB Chain" : (id === 1) ? "Ethereum" : (id === 137) ? "Polygon" : "BNB Chain";
        return text;
    } catch (err) {
        return "";
    }
}

export function formatNumber(num, defaultFixed) {

    try {
        if (defaultFixed && parseInt(defaultFixed) > 0) {
            defaultFixed = parseInt(defaultFixed);
        } else {
            defaultFixed = 5;
        }
        var numval = num.toString();
        numval = convert(numval);

        var chkDeci = numval.split(".");
        var returnNum = num;
        if (chkDeci.length == 2) {
            if (defaultFixed < chkDeci[1].length) {
                returnNum = toFixedWithoutRound(numval, defaultFixed);
            } else {
                var fix = chkDeci[1].length;
                returnNum = toFixedWithoutRound(numval, fix);
            }
        }

        return returnNum;
    } catch (err) {
        console.log(err, 'errerrerrerr')
        return 0;
    }

}

export function CheckDecimal(amount) {

    var amt = amount.toString();
    amt = convert(amt)
    amt = amt.split('.');
    if (amt.length == 2) {
        amount = amt[0];
    }
    return amount;

}

export function getParameterByName(name, url = window.location.href) {
    /* eslint-disable-next-line */
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&;]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


export function removePointValue(amount) {

    amount = amount.toString();
    amount = convert(amount);
    var chkDeci = amount.split(".");
    if (chkDeci && chkDeci.length == 2) {
        amount = chkDeci[0];
    }

    return amount;

}

export function divideValue(amount1, amount2) {
    amount1 = bignumber(amount1);
    amount2 = bignumber(amount2);
    var calVal = divide(amount1, amount2);
    return calVal.toString();
}

export function divideMathDecimal(amount, decimal) {
    amount = bignumber(amount);
    decimal = bignumber(1e18);
    var calVal = divide(amount, decimal);
    return calVal.toString();
}

export function multiplyValue(amount1, amount2) {
    try {
        amount1 = bignumber(amount1)
        amount2 = bignumber(amount2)
        var calVal = multiply(amount1, amount2);
        return parseFloat(calVal.toString());
    } catch (err) {
        return "0";
    }

}

export function addValue(amount1, amount2) {
    try {
        amount1 = bignumber(amount1)
        amount2 = bignumber(amount2)
        var calVal = add(amount1, amount2);
        return calVal.toString();
    } catch (err) {
        return "0";
    }
}

export function subtractValue(amount1, amount2) {
    try {
        amount1 = bignumber(amount1)
        amount2 = bignumber(amount2)
        var calVal = subtract(amount1, amount2);
        return calVal.toString();
    } catch (err) {
        return "0";
    }
}

export function percentageValue(amount1, amount2) {
    try {

    } catch (err) {
        return "0";
    }

}

export const truncateDecimals = (num, decimals) => {
    num = convert(num);
    let s = num.toString(),
        p = s.indexOf(".");
    s += (p < 0 ? ((p = 1 + s.length), ".") : "") + "0".repeat(decimals);
    return s.slice(0, p + 1 + decimals);
};

export function calculateRoundNumber(startDateISO, splitType) {
    console.log(splitType, startDateISO, 'splitType')
    if (!startDateISO || !splitType)
        return {
            roundNumber: 0,
            currentRoundStartDate: new Date(),
            currentRoundEndDate: new Date(),
            remainingDays: 0,
            percentageRemaining: 0,
            status: false,
        };

    const currentDateUTC = new Date(
        Date.UTC(
            new Date().getUTCFullYear(),
            new Date().getUTCMonth(),
            new Date().getUTCDate(),
            new Date().getUTCHours(),
            new Date().getUTCMinutes(),
            new Date().getUTCSeconds()
        )
    );
    let roundNumber = 0;
    let currentRoundStartDate = new Date(startDateISO);
    let currentRoundEndDate;
    let remainingDays = 20;
    let percentageRemaining = 20;

    while (currentRoundStartDate <= currentDateUTC) {
        switch (splitType) {
            case "day":
                currentRoundStartDate = new Date(
                    Date.UTC(
                        currentDateUTC.getUTCFullYear(),
                        currentDateUTC.getUTCMonth(),
                        currentDateUTC.getUTCDate(),
                        0,
                        0,
                        0
                    )
                );
                currentRoundEndDate = new Date(currentRoundStartDate);
                currentRoundEndDate.setUTCDate(currentRoundEndDate.getUTCDate() + 1);
                remainingDays = Math.ceil(
                    (currentRoundEndDate - currentDateUTC) / (1000 * 60 * 60)
                );
                percentageRemaining = (remainingDays / 24) * 100; // percentage of remaining hours in a day
                percentageRemaining = Math.round(100 - percentageRemaining);
                remainingDays = 1;
                break;
            case "week":
                currentRoundEndDate = new Date(currentRoundStartDate);
                currentRoundEndDate.setUTCDate(currentRoundEndDate.getUTCDate() + 6);
                console.log(currentRoundStartDate, currentRoundEndDate, 'weekkdateeeeee')
                break;
            case "month":
                currentRoundEndDate = new Date(currentRoundStartDate);
                currentRoundEndDate.setUTCMonth(
                    currentRoundEndDate.getUTCMonth() + 1
                );
                currentRoundEndDate.setUTCDate(currentRoundEndDate.getUTCDate() - 1);
                break;
            case "Quarterly":
                currentRoundEndDate = new Date(currentRoundStartDate);
                currentRoundEndDate.setUTCMonth(
                    currentRoundEndDate.getUTCMonth() + 3
                );
                currentRoundEndDate.setUTCDate(currentRoundEndDate.getUTCDate() - 1);
                break;
            case "half":
                currentRoundEndDate = new Date(currentRoundStartDate);
                currentRoundEndDate.setUTCMonth(
                    currentRoundEndDate.getUTCMonth() + 6
                );
                currentRoundEndDate.setUTCDate(currentRoundEndDate.getUTCDate() - 1);
                break;
            case "full":
                currentRoundEndDate = new Date(currentRoundStartDate);
                currentRoundEndDate.setUTCFullYear(
                    currentRoundEndDate.getUTCFullYear() + 1
                );
                currentRoundEndDate.setUTCDate(currentRoundEndDate.getUTCDate() - 1);
                break;
            default:
                console.error(
                    'Invalid split type. Use "day", "week", "Monthly", "Quarterly", "half", or "full".'
                );
        }

        roundNumber++;

        if (
            currentDateUTC >= currentRoundStartDate &&
            currentDateUTC <= currentRoundEndDate
        ) {
            if (splitType !== "day") {
                remainingDays = Math.ceil(
                    (currentRoundEndDate - currentDateUTC) / (1000 * 60 * 60 * 24)
                );
                const totalDays =
                    Math.ceil(
                        (currentRoundEndDate - currentRoundStartDate) /
                        (1000 * 60 * 60 * 24)
                    ) + 1;
                percentageRemaining = (remainingDays / totalDays) * 100;
                percentageRemaining = Math.round(100 - percentageRemaining);
            }
            break;
        } else {
            currentRoundStartDate = new Date(currentRoundEndDate);
            currentRoundStartDate.setUTCDate(currentRoundStartDate.getUTCDate() + 1);
        }
    }
    return {
        roundNumber: roundNumber,
        currentRoundStartDate: currentRoundStartDate.toISOString(),
        currentRoundEndDate: currentRoundEndDate.toISOString(),
        remainingDays: remainingDays,
        percentageRemaining: percentageRemaining,
        status: true,
    };
}


//   const formatDate = dateString => {
//     const date = new Date(dateString);
//     const options = { month: "short", day: "numeric", year: "numeric" };
//     return date.toLocaleDateString("en-US", options);
//   };


export async function getFormatMulticall(results, name, pos) {

    try {
        var returnVal = (results && results.results && results.results[name]
            && results.results[name].callsReturnContext &&
            results.results[name].callsReturnContext &&
            results.results[name].callsReturnContext[pos] &&
            results.results[name].callsReturnContext[pos].returnValues &&
            results.results[name].callsReturnContext[pos].returnValues[0]) ?
            results.results[name].callsReturnContext[pos].returnValues[0] : "";
        return returnVal;
    } catch (err) {
        return "";
    }
}

export async function getFormatMulticall1(results, name, pos) {

    try {
        var returnVal = (results && results.results && results.results[name]
            && results.results[name].callsReturnContext &&
            results.results[name].callsReturnContext &&
            results.results[name].callsReturnContext[pos] &&
            results.results[name].callsReturnContext[pos].returnValues &&
            results.results[name].callsReturnContext[pos].returnValues) ?
            results.results[name].callsReturnContext[pos].returnValues : "";
        return returnVal;
    } catch (err) {
        return "";
    }
}


export function tokenValue(rate, amt, benifit) {
    var perToken = rate * amt;
    var swapToken = perToken / 1000000;
    benifit = parseFloat(benifit)
    console.log(rate, amt, benifit, 'rate, amt, benifit', swapToken)
    var bonus = (swapToken * benifit) / 100;
    swapToken = swapToken + bonus;

    return swapToken ? {
        swapToken: formatNumber(swapToken, 6),
        bonusVal: bonus
    } : { swapToken: 0, bonusVal: 0 }
}